import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_9 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "9")
  const titlePrefix = statusContent.titleText || 'ยืนยันสิทธิ์'

  return (
    <Pane
      color="#1b4332"
      fontWeight={700}
      backgroundColor="#d8f3dc"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={16}
      fontFamily=""
      justifyContent="flex-start"
    >
      <Text color="#1b4332" fontWeight={700}>
        {titlePrefix} {row.QUOTA_NAME}{" "}
        {row.ROB_NAME !== null ? row.ROB_NAME : ""}
      </Text>
      <Text color="#1b4332" fontWeight={700}>
        {row.Major1_faculty_name}{" "}
        {" หลักสูตร " + row.Major1_LEVEL_OPEN_NAME}
      </Text>
      <br />
      <Text color="#1b4332" fontWeight={700}>
        {row.Major1_MAJOR_ID + " : " + row.Major1_MAJOR_NAME}
      </Text>
      {statusContent.bodyText ? (
        <Text color="#1b4332" fontWeight={700} marginTop={4}>
          {statusContent.bodyText}
        </Text>
      ) : null}
    </Pane>
  )
}

export default StatusRegister_9
